<template>
  <div>
    <el-dialog :visible.sync="editShow" width="70%" title="机构" :close-on-click-modal="false">
      <el-form :model="form" label-width="auto" :rules="rules" ref="form">
        <div class="flex">
          <div class="flex-1">
            <el-form-item label="类型" required>
              <el-radio-group v-model="form.type">
                <el-radio label="teach_paypal">运动机构</el-radio>
                <el-radio label="school">学校</el-radio>
                <el-radio label="mall">商场</el-radio>
                <el-radio label="outside">第三方</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="机构名称" required prop="mechanism_name">
              <el-input
                v-model="form.mechanism_name"
                placeholder="机构名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="课程类目">
              <el-radio-group
                v-model="form.categories"
                @change="changeCateType"
              >
                <el-radio label="体育运动">体育运动</el-radio>
                <el-radio label="休闲生活">休闲生活</el-radio>
                <el-radio label="夜校">夜校</el-radio>
                <!-- <el-radio label="陪练">陪练</el-radio> -->
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否分店">
              <el-switch
                v-model="sub_mec"
                active-text="分店"
                inactive-text="主店"
              >
              </el-switch>
            </el-form-item>
             <el-form-item label="生成子账号"  v-if="sub_mec">
              <el-checkbox v-model="if_admin" @change="changeSubAccount"></el-checkbox>
            </el-form-item>
            <el-form-item label="是否社区机构">
              <el-switch
                @change="communityChange"
                v-model="form.is_community"
                active-text="是"
                inactive-text="否"
              >
              </el-switch>
            </el-form-item>
             <el-form-item label="是否联营机构">
              <el-switch
                v-model="form.is_union"
                active-text="是"
                inactive-text="否"
              >
              </el-switch>
            </el-form-item>
            <el-form-item label="联营方式" v-if="form.is_union">
          <el-select v-model="form.union_way" placeholder="联营方式" clearable>
            <el-option
              :label="v.name"
              v-for="(v, i) in stageType"
              :value="v.value"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
            <el-form-item label="所属物业" v-if="form.is_community">
              <cooperatorSelect
                :condition="{ type: 'property' }"
                :coopid.sync="coop_id"
                :placeholder="coopPlaceholder"
              ></cooperatorSelect>
            </el-form-item>

            <el-form-item label="所属机构" required v-if="sub_mec" key="mec">
              <el-select
                v-model="form.mechanismName"
                :placeholder="mecPlaceholder"
                filterable
                clearable
                remote
                :remote-method="searchOrgName"
              >
                <el-option
                  v-for="(item, index) in mechanism_name_list"
                  :key="index"
                  :label="item.mechanism_name"
                  :value="item.id"
                  @click.native="changeMec(item)"
                ></el-option>
              </el-select>
            </el-form-item>
           
            <el-form-item label="选择类目" required key="cate">
              <div @click="cateShow = true">
                {{ form.categories_child || "选择子类目" }}
              </div>
            </el-form-item>
            <el-form-item label="运营方" required key="operate">
              <el-radio-group v-model="form.operate">
                <el-radio label="settle">机构运营</el-radio>
                <el-radio label="haima_self">官方直营</el-radio>
                <el-radio label="unused">闲置区</el-radio>
                <el-radio label="showroom">展厅</el-radio>
                <el-radio label="third_party">三方运营</el-radio>
              </el-radio-group>
              <div>
                不同运营方式的结算方式不同
              </div>
            </el-form-item>
            <el-form-item label="省市区" required key="city">
              <city-select @change="changeCity" :temp="cityList"></city-select>
            </el-form-item>
            <el-form-item label="详细地址" required prop="mechanism_addr">
              <el-input v-model="form.mechanism_addr">
                <addr-select
                  slot="append"
                  @getform="addMecAddr"
                  type="icon"
                ></addr-select>
              </el-input>
            </el-form-item>
            <el-form-item label="经度" prop="longitude">
              <el-input v-model="form.longitude" placeholder="经度"></el-input>
            </el-form-item>
            <el-form-item label="纬度" prop="latitude">
              <el-input v-model="form.latitude" placeholder="纬度"></el-input>
            </el-form-item>
            <el-form-item
              label="机构电话"
              required
              prop="mechanism_telephone"
              key="mechanism_telephone"
            >
              <el-input
                v-model="form.mechanism_telephone"
                placeholder="机构电话，用户联系"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="负责人姓名"
              required
              v-if="if_admin || !sub_mec"
              key="contacts"
            >
              <el-input v-model="form.contacts" placeholder="负责人"></el-input>
            </el-form-item>
            <el-form-item
              label="负责人电话"
              required
              v-if="if_admin || !sub_mec"
              key="contact_telephone"
            >
              <el-input
                v-model="form.contact_telephone"
                placeholder="登录账号"
              ></el-input>
            </el-form-item>
            <el-form-item label="抽成比例">
              <el-input v-model="form.commission_rate" placeholder="如0.1，默认0"></el-input>
            </el-form-item>
             <el-form-item label="到账周期/天">
              <el-input v-model="form.bill_cycle" placeholder="天，默认0"></el-input>
            </el-form-item>
          </div>
          <div class="flex-1">
             <el-form-item
              label="营业时间"
            >
              <el-input
                v-model="form.opentime"
                placeholder="周一至周日,09:00-20:00"
              ></el-input>
            </el-form-item>
            <el-form-item label="是否优选">
              <el-radio-group v-model="form.is_recommend">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">优选</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="运营结束时间" v-if="form.type == 'venue'">
              <el-date-picker
                v-model="form.expired_time"
                type="date"
                value-format="yyyy-MM-dd 00:00:00"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item label="机构简介">
              <el-input
                type="textarea"
                v-model="form.introduction_content"
              ></el-input>
            </el-form-item>
            <el-form-item label="机构logo" required>
              <avatar-uploader
                @getImgUrl="(v) => (form.mechanism_logo = v)"
                :url="temp.mechanism_logo"
                :clear="if_clear"
              ></avatar-uploader>
            </el-form-item>
            <el-form-item label="营业执照" ref="support" required>
              <images-uploader
                @getImgUrl="(v) => (form.support_means = v)"
                :urls="temp.support_means"
                :clear="if_clear"
              >
              </images-uploader>
            </el-form-item>
            <el-form-item label="机构资质">
              <images-uploader
                @getImgUrl="(v) => (form.qualifications_pic = v)"
                :urls="temp.qualifications_pic"
                :clear="if_clear"
              >
              </images-uploader>
            </el-form-item>
            <el-form-item label="简介图片">
              <images-uploader
                @getImgUrl="(v) => (form.introduction_pic = v)"
                :urls="temp.introduction_pic"
                :clear="if_clear"
              >
              </images-uploader>
            </el-form-item>
            <el-form-item label="机构门面图">
              <images-uploader
                @getImgUrl="(v) => (form.facade_view = v)"
                :urls="temp.facade_view"
                :clear="if_clear"
              >
              </images-uploader>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editShow = false">取 消</el-button>
        <el-button v-if="form.id" type="primary" @click="updateForm"
          >修 改</el-button
        >
        <el-button v-else type="primary" @click="submitForm">添 加</el-button>
      </span>
      <el-dialog
        title="选择类目"
        :visible.sync="cateShow"
        width="60%"
        append-to-body
      >
        <el-transfer
          filterable
          filter-placeholder="请选择绑定的科目"
          v-model="changeCates"
          :data="categories_child_list"
          :props="{
            key: 'name',
            label: 'name',
          }"
          :titles="['所有类目', '拥有类目']"
        >
        </el-transfer>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cateShow = false">取 消</el-button>
          <el-button type="primary" @click="confirmCategory">确 定</el-button>
        </span>
      </el-dialog>
    </el-dialog>
  </div>
</template>
  
  <script>
import { rules } from "./rules_v";
import { ObjectChangedValue } from "@/js/utils";
import cooperatorSelect from "@/components/select/cooperatorSelect.vue";
import { stageType } from "@/views/categoriesManage/components/dict.js";
export default {
  components: {
    cooperatorSelect,
  },
  data() {
    return {
      stageType,
      form: {
        categories: "体育运动",
        operate: "settle",
        type: "teach_paypal",
      },
      temp: {},
      rules: rules,
      sub_mec: false,
      coop_id: "",
      editShow: false,
      categories_child_list: [],
      select_mechanism: "",
      mechanism_name_list: [],
      venues_list: "",
      if_clear: true,
      count: 1,
      cityList: [],
      if_admin: false,
      cateShow: false,
      changeCates: [],
      coopPlaceholder: "输入名称或电话",
      mecPlaceholder: "输入名称或电话",
    };
  },
  mounted() {},

  methods: {
    changeSubAccount(v){
        if(!v){
          this.form.contacts = ''
          this.form.contact_telephone = ''
        }
    },
    communityChange(v) {
      if (v) {
        this.form.operate = "haima_self";
      }
    },
    confirmCategory() {
      this.form.categories_child = this.changeCates.join("/");
      this.cateShow = false;
    },
    changeCateType() {
      this.changeCates = [];
      this.getCateList();
    },
    getCateList() {
      let url = "/user/mechanismCategory/queryListPageChild";
      let data = {
        status: 2,
        type: 2,
        source: "课程",
      };
      if (this.form.categories != "体育运动") {
        data.source = this.form.categories;
      }

      this.$axios
        .get(url, {
          params: data,
        })
        .then((res) => {
          this.categories_child_list = res.data.data;
        });
    },
    // 新增机构地址
    addMecAddr(addr) {
      if (addr.address) {
        this.$set(this.form, "province", addr.province);
        this.$set(this.form, "city", addr.city);
        this.$set(this.form, "district", addr.district);
        this.$set(this.form, "address", addr.address);
        this.cityList = [];
        this.cityList.push(addr.province);
        this.cityList.push(addr.city);
        this.cityList.push(addr.district);
      }

      this.$set(this.form, "latitude", addr.addrPoint.lat);
      this.$set(this.form, "longitude", addr.addrPoint.lng);
    },
    changeCity(v) {
      this.cityList = v;
      this.form.province = v[0];
      this.form.city = v[1];
      this.form.district = v[2];
    },
    changeMec(e) {
      this.form.mechanismName = e.mechanism_name;
      this.cityList = [];
      this.cityList.push(e.province);
      this.cityList.push(e.city);
      this.cityList.push(e.district);
      this.$set(this.form, "province", e.province);
      this.$set(this.form, "city", e.city);
      this.$set(this.form, "district", e.district);
      this.$set(this.form, "categories_child", e.categories_child);
      this.$set(this.form, "mechanism_telephone", e.mechanism_telephone);
      this.$set(this.form, "introduction_content", e.introduction_content);
      this.$set(this.form, "mechanism_logo", e.mechanism_logo);
      this.$set(this.form, "support_means", e.support_means);
      this.$set(this.form, "qualifications_pic", e.qualifications_pic);
      this.$set(this.form, "introduction_pic", e.introduction_pic);
      this.$set(this.form, "facade_view", e.facade_view);
      this.$set(this.form, "parent_id", e.id);
      if(e.type == 'mall'){
        this.$set(this.form, "mechanism_addr", e.mechanism_addr);
        this.$set(this.form, "longitude", e.longitude);
        this.$set(this.form, "latitude", e.latitude);
      }
      this.temp = {
        mechanism_logo: e.mechanism_logo,
        support_means: e.support_means,
        qualifications_pic: e.qualifications_pic,
        introduction_pic: e.introduction_pic,
        facade_view: e.facade_view,
      };
    },
    editDataInfo() {},
    open(info) {
      if (info && info.id) {
        this.temp = Object.assign({}, info);
        this.form = info;
        this.cityList = [];
        this.cityList.push(info.province);
        this.cityList.push(info.city);
        this.cityList.push(info.district);
        this.temp.data = { ...this.form };
        this.sub_mec = info.parent_id > 0;
        this.coop_id = info.cooperator_id;
        if (info.categories_child) {
          this.changeCates = info.categories_child.split("/");
        } else {
          this.changeCates = [];
        }

        if (info.cooperator_id > 0) {
          this.coopPlaceholder = info.map.cooperator_name;
        }
        if (info.parent_id > 0) {
          this.mecPlaceholder = info.map.mechanism_name;
        }
      } else {
        this.if_clear = !this.if_clear;
        this.form = Object.assign(
          { categories: "体育运动", operate: "settle", type: "teach_paypal",opentime:'周一至周日,09:00-20:00' },
          info
        );
        this.sub_mec = false;
        this.temp = {};
        this.coop_id = "";
        this.coopPlaceholder = "输入名称或电话";
        this.mecPlaceholder = "输入名称或电话";
      }
      this.getCateList();
      this.editShow = true;
    },
    updateForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.updateData();
        }
      });
    },
    submitForm() {
      if (!this.form.support_means) {
        this.$message("请上传营业执照");
        return;
      }
      if (!this.form.mechanism_logo) {
        this.$message("请上传logo");
        return;
      }

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.insertData();
        }
      });
    },
    insertData() {
      let url = "/user/mastermechanism/insertAppointmentMechanismInfo";
      this.form.cooperator_id = this.coop_id || 0;
      this.form.status = 2;
      const loading = this.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios
        .post(url, this.form)
        .then((res) => {
          loading.close();
          this.$message({ type: "warning", message: "添加成功!" });
          this.editShow = false;
          this.form = {};
          this.$emit("success");
        })
        .catch((err) => {
          loading.close();
        });
    },
    updateData() {
      this.form.cooperator_id = this.coop_id || 0;
      let data = ObjectChangedValue(this.temp.data, this.form);
      data.id = this.form.id;

      let url = "/user/mastermechanism/update";
      const loading = this.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios
        .post(url, data)
        .then((res) => {
          loading.close();
          this.$message({ type: "success", message: "修改成功!" });
          this.editShow = false;
          this.form = {};
          this.temp = {};
          this.$emit("success");
        })
        .catch((err) => {
          loading.close();
        });
    },
    // 机构查询远程查询
    searchOrgName(query) {
      if (query && typeof query == "string") {
        let url = "/user/mastermechanism/queryByMessage";
        let data = {
          // type: this.form.type,
          pageSize: 50,
          currentPage: 1,
          status: 2,
          parent_id:0
        };
        const numberReg = /^\d/;
        numberReg.test(query)
          ? (data.mechanism_telephone = query)
          : (data.mechanism_name = query);
        this.$axios
          .get(url, {
            params: data,
          })
          .then((res) => {
            this.mechanism_name_list = res.data.data.rows;
          })
          .catch((err) => {});
      }
    },
  },
};
</script>
  
  <style lang="scss" scoped>
</style>